import { type ExtractAtomArgs, getDefaultStore } from 'jotai'

import { toastAtom } from '@/store/toast.store'

/**
 * Helper for triggering jotai based toasts outside React lifecycle
 */
export const triggerToast = (
  newToast: ExtractAtomArgs<typeof toastAtom>['0'],
) => getDefaultStore().set(toastAtom, newToast)
